import { render, staticRenderFns } from "./CommentContents.vue?vue&type=template&id=5b3403f0&scoped=true&"
import script from "./CommentContents.vue?vue&type=script&lang=js&"
export * from "./CommentContents.vue?vue&type=script&lang=js&"
import style0 from "./CommentContents.vue?vue&type=style&index=0&id=5b3403f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3403f0",
  null
  
)

export default component.exports